import { Affiliate, User } from "@/types";
import { formatUserRoleToName, ResourceName } from "@/utils";
import { FC } from "react";
import { Datagrid, FunctionField, List, Pagination } from "react-admin";
import { TopToolbar } from "../top-toolbar";
import { UserNameCell } from "../user-name-cell";

const PaymentsList: FC = () => {
  return (
    <List<User>
      perPage={30}
      actions={<TopToolbar />}
      pagination={<Pagination rowsPerPageOptions={[10, 15, 30, 50]} />}
      sort={{ field: "duePayment", order: "DESC" }}
      empty={<></>} // needn't empty list component
    >
      <Datagrid
        rowClick={"show"}
        bulkActionButtons={false}
        style={{ tableLayout: "fixed" }}
      >
        <UserNameCell
          label="Name"
          source="id"
          resourceName={ResourceName.AFFILIATE_PAYOUTS}
          sortable={false}
        />
        <FunctionField<Affiliate>
          label="Role"
          sortable={false}
          render={({ user }) =>
            user?.role ? formatUserRoleToName(user.role) : "Affiliate"
          }
        />
        <FunctionField<Affiliate>
          sortable={true}
          label="Total Earnings"
          source="earnings"
          render={({ earnings }) => `$${earnings / 100}`}
        />
        <FunctionField<Affiliate>
          sortable={true}
          label="Due Payment"
          source="duePayment"
          render={({ duePayment }) => `$${duePayment / 100}`}
        />
      </Datagrid>
    </List>
  );
};

export { PaymentsList };
